import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const soulIcon = require("../../Assets/Images/SOUL.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  container: {
    gap: "20px",
    width: "100%",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#426B88",
    textAlign: "left",
    lineHeight: "35px",
    height: "35px",
    marginBottom: "5px",
    fontFamily: "Lato",
  },
  row: {
    flexDirection: "row",
    alignItems: "flex-start",
    gap: "15px",
    width: "100%",
  },
  icon: {
    width: "78px",
    height: "78px",
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-start",
  },
  section: {
    width: "100%",
    height: "79px",
    borderRadius: "5px",
    padding: "10px",
    backgroundColor: "#EAF1F5",
  },
  highlight: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#00577D",
    textAlign: "left",
    lineHeight: "18px",
    fontFamily: "Lato",
  },
  text: {
    fontSize: "12px",
    lineHeight: "18px",
    color: "#00577D",
    fontWeight: "400",
    marginBottom: "0px",
  },
  textContainer: {
    flex: 1,
    justifyContent: "flex-start",
  },
  textPoints: {
    gap: "35px",
    height: "36px",
    color: "#00577D",
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    flexDirection: "row",
    justifyContent: "left",
    marginLeft: "10px",
  },
  StrengthSection: {
    width: "100%",
    height: "166px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#F1F8F1",
  },
  ChallengeSection: {
    width: "100%",
    height: "188px",
    borderRadius: "5px",
    padding: "10px",
    gap: "10px",
    backgroundColor: "#FFF0EC",
  },
});

const GroupSoulStarter = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>GROUP PROFILE: SOUL STARTER</Text>

      {/* Image + Text in One Row */}
      <View style={styles.row}>
        <Image src={soulIcon} style={styles.icon} />
        <View style={styles.textContainer}>
          <Text style={styles.text}>
            The Soul Starter Group is defined by its emphasis on depth,
            creativity, and meaningful insights in its approach to projects and
            relationships. Driven by the pursuit of meaning, this group often
            utilizes vision-casting, stories, and metaphors to illuminate the
            purpose behind their actions and inspire all group members.
          </Text>
        </View>
      </View>

      {/* Heart Starter Questions */}
      <View style={styles.section}>
        <Text style={styles.highlight}>Core questions guiding the group:</Text>
        <View style={styles.textPoints}>
          <View>
            <Text>• Why should we undertake this project?</Text>
            <Text>• What is the purpose behind our current strategy?</Text>
          </View>
          <View>
            <Text>• Why is this goal important to us?</Text>
            <Text>• What direction should we pursue and why?</Text>
          </View>
        </View>
      </View>

      {/* Strengths Section */}
      <View style={styles.StrengthSection}>
        <Text style={styles.highlight}>Strengths:</Text>
        <Text style={styles.text}>
          The Soul Starter Group excels in vision and innovation, leveraging
          deep insights and creative approaches to address complex challenges.
          They are adept at offering perspective and wisdom, inspiring the group
          through compelling narratives and visionary ideas. Their ability to
          see and articulate a deeper meaning not only motivates them but also
          serves as a guiding light in their endeavors, making them effective
          mentors and leaders within the organization.
        </Text>
      </View>

      {/* Challenges Section */}
      <View style={styles.ChallengeSection}>
        <Text style={styles.highlight}>Challenges:</Text>
        <Text style={styles.text}>
          Their focus on ideas and ideals can sometimes lead to challenges in execution. The Soul Starter Group may struggle with the granularity of day-to-day tasks and can become overwhelmed by the mundane aspects of project management. Their need for meaningful engagement can also result in hesitation or withdrawal when faced with misunderstood or undervalued ideas, potentially leading to isolation or a lack of decisive action.
        </Text>
        <Text style={styles.text}>
          Overall, the Soul Starter Group contributes a unique and invaluable perspective that enhances the organizational culture and projects. They are committed to not only envisioning a better future but also to sharing that vision in ways that foster growth and understanding across the group.
        </Text>
      </View>
    </View>
  );
};

export default GroupSoulStarter;
